import { Col, Row } from "react-bootstrap";
import { CustomCard } from "../common-styling";

// One section of the dashboard: heading and help text, an optional notice,
// tiles left and chart right, then the list (children). Without tiles and
// chart (HubSpot not readable) only the notice shows. The page spaces the
// sections, so a section has no outer margin.
const KpiSection = ({ title, help, notice, tiles, chart, children }) => (
  <div>
    <h5 className="mb-1">{title}</h5>
    <p className="text-secondary small mb-3">{help}</p>
    {notice}
    {tiles && chart && (
      <Row className="g-3 mb-3">
        <Col md={4}>{tiles}</Col>
        <Col md={8}>
          <CustomCard className="p-3">{chart}</CustomCard>
        </Col>
      </Row>
    )}
    {children}
  </div>
);

export default KpiSection;
